import { Component, Input, OnChanges } from '@angular/core'
import { Sale } from '../domain/Sale'
import { Venue } from '../domain/Venue'
import { Voucher } from '../domain/Voucher'
import { SKU } from '../domain/SKU'
import { LineItem } from '../domain/LineItem'
import { truncateRichTextHtml } from '../utilities/rich-text'

type LineItemViewModel = {
    lineItem: LineItem,
    sku: SKU | null,
    total: number,
}

@Component({
    selector: 'app-voucher-payment-confirmation',
    templateUrl: './voucher-payment-confirmation.component.html',
})
export class VoucherPaymentConfirmationComponent implements OnChanges {

    @Input() venue!: Venue
    @Input() voucher!: Voucher
    @Input() sale!: Sale
    sku: SKU | null = null
    voucherDescriptionContent = ''
    lineItemViewModels: LineItemViewModel[] = []
    voucherLineItemViewModels: LineItemViewModel[] = []
    postalAddressLines: string[] = []
    deliveryMethodLabel = ''
    deliveryLeadText = ''
    deliveryEmailAddress: string | null = null
    deliveryRecipientName: string | null = null
    hasPostalDelivery = false
    hasEmailDelivery = false
    orderTotal = 0
    private readonly descriptionCharacterLimit = 200

    constructor() { }

    ngOnChanges() {
        this.voucherDescriptionContent = truncateRichTextHtml(
            this.voucher.description ?? '',
            this.descriptionCharacterLimit
        )
        this.lineItemViewModels = this.sale.order.lineItems.map(lineItem => ({
            lineItem,
            sku: this.voucher.getSKUWithId(lineItem.skuId),
            total: lineItem.amount * lineItem.quantity,
        }))
        this.voucherLineItemViewModels = this.lineItemViewModels.filter(viewModel => {
            return !viewModel.lineItem.isPostalDeliveryFee
        })
        this.updateDeliveryDetails()
        this.orderTotal = this.sale.order.total()
        if (this.voucherLineItemViewModels.length === 0) {
            return
        }
        const skuIdSoldBySale = this.voucherLineItemViewModels[0].lineItem.skuId
        this.sku = this.voucher.getSKUWithId(skuIdSoldBySale)
    }

    private updateDeliveryDetails() {
        const deliveryDetails = this.sale.deliveryDetails
        this.postalAddressLines = deliveryDetails?.postalDeliveryAddress?.lines().split('\n') ?? []
        this.deliveryEmailAddress = deliveryDetails?.emailAddress ?? null
        this.deliveryRecipientName = deliveryDetails?.name ?? null
        this.hasPostalDelivery = this.postalAddressLines.length > 0
        this.hasEmailDelivery = !this.hasPostalDelivery && this.deliveryEmailAddress !== null

        if (this.hasPostalDelivery) {
            this.deliveryMethodLabel = 'Postal delivery'
            this.deliveryLeadText = `${this.venue.voucherDisplayName()} will post this voucher to the address below.`
        } else if (this.hasEmailDelivery) {
            this.deliveryMethodLabel = 'Email delivery'
            this.deliveryLeadText = 'The voucher will be sent by email.'
        } else {
            this.deliveryMethodLabel = 'Delivery details'
            this.deliveryLeadText = 'Delivery details for this order are being prepared.'
        }
    }
}
